import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import './usersForm.scss';

import usersStore from 'storeState/users';
import generalStore from 'storeState/general';
import authStore from 'storeState/auth';
import projectsStore from 'storeState/projects';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';

import FormField from 'views/formField/FormField';
import FormHeading from 'views/formHeading/FormHeading';
import FormButtons from 'views/formButtons/FormButtons';
import Button from 'views/button/Button';
import SelectList from 'views/selectList/SelectList';
import Checkbox from 'views/checkbox/Checkbox';

const defaultState = {
    inputName: "",
    selectedLocales: [],
    localeOptions: [],
    selectedProjects: [],
    projectsOptions: [],
    isTenantTranslator: false,
    isTenantAdmin: false,
    isGlobalAdmin: false,
    email: "",
    password: "",
    password_confirm: "",
    old_password: ""
};

export class UsersForm extends Component {

    static contextTypes = {
        intl: PropTypes.object,
        user_id: PropTypes.string
    }

    constructor() {
        super();

        this.state = {
            ...defaultState
        }
    }

    componentWillMount() {

    }

    handleNameChange = (ev) => {
        this.setState({
            inputName: ev.target.value
        });
    }

    handleEmailChange = (ev) => {
        this.setState({
            email: ev.target.value
        });
    }

    componentDidMount = () => {
        this.updateProjectsOptions();
        this.props.actions.usersListRequest({
            "tenant_id": this.props.currentTenantId
        });
    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.users != this.props.users || nextProps.user_id != this.props.user_id) {
            setTimeout(()=> {
                this.user = null;
                this.setState({
                    ...defaultState,
                    localeOptions: this.getLocaleOptions(nextProps),
                    projectsOptions: this.getProjectsOptions(nextProps)
                })

                if(nextProps.user_id) {
                    let user = _.find(nextProps.users,(t) => {
                        return t.id==nextProps.user_id;
                    });
                    if(user) {
                        this.user = user;
                        this.setState({
                            inputName: this.user.username,
                            selectedLocales: _.map(this.user.locales, (l) => l.id),
                            selectedProjects: _.map(this.user.projects, (p) => p.id),
                            isTenantAdmin: this.user.tenant_role=="admin",
                            isGlobalAdmin: this.user.global_role=="admin",
                            isTenantTranslator: this.user.tenant_role=="admin" || this.user.tenant_role=="translator",
                            email: this.user.email,
                        });
                    }
                }
            })
        }

        if(nextProps.locales != this.props.locales) {
            setTimeout(() => {
                this.setState({ localeOptions: this.getLocaleOptions(nextProps) });
            });
        }

        if(nextProps.projectsList != this.props.projectsList) {
            setTimeout(() => {
                this.setState({ projectsOptions: this.getProjectsOptions(nextProps) });
            });
        }

        if(nextProps.currentTenantId != this.props.currentTenantId) {
            this.updateProjectsOptions();
        }
    }

    getTenantRoleForSubmission = () => {
        if(this.state.isTenantAdmin) {
            return "admin";
        } else if (this.state.isTenantTranslator) {
            return "translator";
        } else {
            return "read_only"
        }
    }

    getGlobalRoleForSubmission = () => {
        if(this.state.isGlobalAdmin) {
            return "admin";
        } else {
            return "client"
        }
    }

    handleFormSubmit = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }

    handleSaveButtonClick = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        if(!this.form.checkValidity()) {
            this.form.querySelector("input[type=submit]").click();
            return false;
        }

        if(this.user) {
            this.props.actions.userUpdateRequest({
                user_id: this.user.id,
                tenant_id: this.props.currentTenantId,
                user: {
                    username: this.state.inputName,
                    email: this.state.email,
                    current_password: this.state.old_password,
                    password: this.state.password,
                    locales: this.state.selectedLocales,
                    projects: this.state.selectedProjects,
                    tenant_role: this.getTenantRoleForSubmission(),
                    global_role: this.getGlobalRoleForSubmission(),
                    tenant_id: this.props.currentTenantId,
                }
            });
        } else {
            this.props.actions.userCreateRequest({
                tenant_id: this.props.currentTenantId,
                user: {
                    username: this.state.inputName,
                    email: this.state.email,
                    password: this.state.password,
                    tenant_id: this.props.currentTenantId,
                    locales: this.state.selectedLocales,
                    projects: this.state.selectedProjects,
                    tenant_role: this.getTenantRoleForSubmission(),
                    global_role: this.getGlobalRoleForSubmission(),
                }
            });
        }
    }

    handleDeleteButtonClick = (ev) => {
        ev.preventDefault();

        if(this.user) {
            this.props.actions.userDeleteRequest({
                user_id: this.user.id,
                tenant_id: this.props.currentTenantId,
            });
        }
    }

    getLocaleOptions = (props) => {
        return _.map(props.locales, (l) => {
            return {
                value: l.id,
                label: "["+l.string_id+"] "+l.display_name
            }
        })
    }

    handleLocaleSelect = (val) => {
        this.setState({
            selectedLocales: [
                ...this.state.selectedLocales,
                val
            ]
        })
    }

    handleLocaleDelete = (val) => {
        this.setState({
            selectedLocales: _.filter(this.state.selectedLocales, (l) => l != val)
        })
    }

    updateProjectsOptions = (v) => {
        this.props.actions.projectsListRequest({
            "tenant_id": this.props.currentTenantId
        });
    }

    getProjectsOptions = (props) => {
        return _.map(props.projectsList, (l) => {
            return {
                value: l.id,
                label: l.name
            }
        })
    }

    handleProjectSelect = (val) => {
        this.setState({
            selectedProjects: [
                ...this.state.selectedProjects,
                val
            ]
        })
    }

    handleProjectDelete = (val) => {
        this.setState({
            selectedProjects: _.filter(this.state.selectedProjects, (l) => l != val)
        })
    }

    handleTenantAdminToggle = (val) => {
        const willBeAdmin = !this.state.isTenantAdmin;
        this.setState({
            isTenantAdmin: willBeAdmin,
            isTenantTranslator: willBeAdmin ? true : this.state.isTenantTranslator
        })
    }
    handleTenantTranslatorToggle = (val) => {
        const willBeTranslator = !this.state.isTenantTranslator;
        this.setState({
            isTenantTranslator: willBeTranslator,
            isTenantAdmin: willBeTranslator ? this.state.isTenantAdmin : false
        })
    }

    handleGlobalAdminToggle = (val) => {
        this.setState({
            isGlobalAdmin: !this.state.isGlobalAdmin
        })
    }

    handleOldPasswordChange = (ev) => {
        this.setState({
            old_password: ev.target.value
        });
    }

    handlePasswordChange = (ev) => {
        this.setState({
            password: ev.target.value
        });
    }

    handlePasswordConfirmChange = (ev) => {
        this.setState({
            password_confirm: ev.target.value
        });
    }

    render() {
        return (
            <form className={`users-form`} ref={(el) => {this.form=el;}} method="POST" onSubmit={(ev)=>{this.handleFormSubmit(ev)}}>
                <FormHeading>
                    <If condition={this.user}>
                        <span>
                            <FormattedMessage id="usersForm.heading.editing" defaultMessage="Editing" />
                            &nbsp;
                            {this.user.username}
                        </span>
                    <Else />
                        <span>
                            <FormattedMessage id="usersForm.heading.new" defaultMessage="New user" />
                        </span>
                    </If>
                </FormHeading>
                <If condition={this.props.loginData.global_role=="admin" || (this.props.loginData.tenant_role=="admin" && (!this.user || this.props.loginData.id != this.user.id))}>
                    <FormField label={<FormattedMessage id="usersForm.name.label" defaultMessage="Name" />}>
                        <input
                            type="text"
                            value={this.state.inputName}
                            onChange={this.handleNameChange}
                            autocomplete="off"
                        />
                    </FormField>
                </If>

                <div>
                    <If condition={this.props.loginData.global_role=="admin" || (this.props.loginData.tenant_role=="admin" && (!this.user || this.props.loginData.id != this.user.id))}>
                        <FormField label={<FormattedMessage id="usersForm.email.label" defaultMessage="Email" />}>
                            <input
                                type="email"
                                value={this.state.email}
                                onChange={this.handleEmailChange}
                                autocomplete="off"
                            />
                        </FormField>
                    </If>
                </div>
                <div>
                    <If condition={this.user && this.props.loginData.id == this.user.id}>
                        <FormField label={<FormattedMessage id="usersForm.old_password.label" defaultMessage="Old Password" />}>
                            <input
                                type="old_password"
                                value={this.state.old_password}
                                onChange={this.handleOldPasswordChange}
                                autocomplete="new-password"
                            />
                        </FormField>
                    </If>
                </div>

                <div>
                    <If condition={this.props.loginData.tenant_role=="admin" || (this.user && (this.props.loginData.id == this.user.id))}>
                        <FormField label={<FormattedMessage id="usersForm.password.label" defaultMessage="Password" />}>
                            <input
                                type="password"
                                minlength={8}
                                value={this.state.password}
                                onChange={this.handlePasswordChange}
                                autocomplete="new-password"
                            />
                        </FormField>
                        <FormField label={<FormattedMessage id="usersForm.password_confirm.label" defaultMessage="Password (Confirm)" />}>
                            <input
                                type="password"
                                minlength={8}
                                value={this.state.password_confirm}
                                onChange={this.handlePasswordConfirmChange}
                                autocomplete="new-password"
                            />
                        </FormField>
                    </If>
                </div>

                <div>
                    <If condition={this.props.loginData.tenant_role=="admin"}>

                        <FormField label={<FormattedMessage id="usersForm.locales.label" defaultMessage="Locales" />}>
                            <SelectList
                                options={this.state.localeOptions}
                                selected={this.state.selectedLocales}
                                onSelect={this.handleLocaleSelect}
                                onDelete={this.handleLocaleDelete}
                            />
                        </FormField>

                        <FormField label={<FormattedMessage id="usersForm.projects.label" defaultMessage="Projects" />}>
                            <SelectList
                                options={this.state.projectsOptions}
                                selected={this.state.selectedProjects}
                                onSelect={this.handleProjectSelect}
                                onDelete={this.handleProjectDelete}
                            />
                        </FormField>
                    </If>
                </div>

                <div>
                    <If condition={this.props.loginData.global_role=="admin" || (this.user && this.props.loginData.tenant_role=="admin" && this.props.loginData.id != this.user.id)}>
                        <FormField label={<FormattedMessage id="usersForm.admin.label" defaultMessage="Admin" />}>
                            <If condition={this.props.loginData.global_role=="admin" || (this.user && this.props.loginData.tenant_role=="admin" && this.props.loginData.id != this.user.id)}>
                                <Checkbox
                                    checked={this.state.isTenantAdmin}
                                    onToggle={this.handleTenantAdminToggle}>
                                    <FormattedMessage id="usersForm.is_tenant_admin.label" defaultMessage="Admin (Company-wide)"/>
                                </Checkbox>
                                <Checkbox
                                    checked={this.state.isTenantTranslator}
                                    onToggle={this.handleTenantTranslatorToggle}>
                                    <FormattedMessage id="usersForm.is_tenant_translator.label" defaultMessage="Translator (Company-wide)"/>
                                </Checkbox>
                            </If>
                            <If condition={this.props.loginData.global_role=="admin"}>
                                <Checkbox
                                    checked={this.state.isGlobalAdmin}
                                    onToggle={this.handleGlobalAdminToggle}>
                                    <FormattedMessage id="usersForm.is_gobal_admin.label" defaultMessage="Global-Admin"/>
                                </Checkbox>
                            </If>
                        </FormField>
                    </If>
                </div>

                <FormButtons>
                    <If condition={this.user && this.user.id != this.props.loginData.id}>
                        <Button onClick={(ev)=>{return this.handleDeleteButtonClick(ev)}}>
                            <FormattedMessage id="usersForm.delete" defaultMessage="Delete" />
                        </Button>
                    </If>

                    <Button onClick={(ev)=>{return this.handleSaveButtonClick(ev)}}>
                        <If condition={this.user}>
                            <FormattedMessage id="usersForm.save.update" defaultMessage="Save" />
                        <Else />
                            <FormattedMessage id="usersForm.save.new" defaultMessage="Create" />
                        </If>
                    </Button>
                </FormButtons>
                <input type="submit" style={{"display":"none"}} />
            </form>
        );
    }
}


export default connect((state, props) => {
  return {
    projectsList: projectsStore.selectors.projectsList(state),
    users: usersStore.selectors.usersList(state),
    locales: generalStore.selectors.locales(state),
    currentTenantId: authStore.selectors.currentTenantId(state),
    loginData: authStore.selectors.loginData(state),
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, usersStore.actions, authStore.actions, projectsStore.actions), dispatch)
  }
})(UsersForm)



// WEBPACK FOOTER //
// ./src/components/views/usersForm/UsersForm.js